import { Button } from '@mui/material';
import { CONTRACT_TYPE } from './constants';
import PropTypes from 'prop-types';

export const tableColumns = ({ handleOpenContract }) => {
  return [
    {
      accessorKey: 'contractId',
      header: 'Id',
      enableSorting: true,
      enableFiltering: true,
      filterVariant: 'textField',
    },
    {
      accessorKey: 'srcOrgName',
      header: 'From',
      enableSorting: true,
      enableFiltering: true,
      filterVariant: 'textField',
    },
    {
      accessorKey: 'dstOrgName',
      header: 'To',
      enableSorting: true,
      enableFiltering: true,
      filterVariant: 'textField',
    },
    {
      accessorKey: 'quota',
      header: 'Quota',
      enableSorting: true,
      enableFiltering: true,
      filterVariant: 'textField',
    },
    {
      accessorKey: 'used',
      header: 'Used',
      enableSorting: true,
      enableFiltering: true,
      filterVariant: 'textField',
    },
    {
      accessorKey: 'monthlyInvoiceDate',
      header: 'Monthly Invoice Date',
      enableSorting: true,
      enableFiltering: true,
      filterVariant: 'textField',
    },
    {
      accessorKey: 'details',
      header: 'Details',
      enableSorting: false,
      enableFiltering: false,
      enableFacetedValues: false,
      Cell: ({ renderedCellValue }) => {
        return detailsCell({ renderedCellValue, handleOpenContract });
      },
    },
    {
      accessorKey: 'delete',
      header: 'Delete',
      enableSorting: false,
      enableFiltering: false,
      enableFacetedValues: false,
      Cell: ({ renderedCellValue }) => {
        return deleteCell({ renderedCellValue, handleOpenContract });
      },
    },
  ];
};

//! TODO Language
const detailsCell = ({ renderedCellValue, handleOpenContract }) => {
  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          handleOpenContract(renderedCellValue, CONTRACT_TYPE.DETAILS);
        }}>
        Details
      </Button>
    </div>
  );
};

detailsCell.propTypes = {
  renderedCellValue: PropTypes.object.isRequired,
  handleOpenContract: PropTypes.func.isRequired,
};

//! TODO Language
const deleteCell = ({ renderedCellValue, handleOpenContract }) => {
  return (
    <div>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => {
          handleOpenContract(renderedCellValue, CONTRACT_TYPE.DELETE);
        }}>
        Delete
      </Button>
    </div>
  );
};

deleteCell.propTypes = {
  renderedCellValue: PropTypes.object.isRequired,
  handleOpenContract: PropTypes.func.isRequired,
};
